module.exports = __webpack_public_path__ + "static/img/m_name.5787861.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/mz/m_name.png
// module id = K9Hi
// module chunks = 7